import MultichoiceDisplay from './MultichoiceDisplay_v2';

export default MultichoiceDisplay;
